import { render, staticRenderFns } from "./ProgrammesCardPartner.vue?vue&type=template&id=a4c0da3a&"
import script from "./ProgrammesCardPartner.vue?vue&type=script&lang=js&"
export * from "./ProgrammesCardPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports